/* Online Organics — Article Carousel (namespaced: ooag-) */
/* Loop mode: clones edges to create seamless wrap-around */

(function () {
  function initCarousel(root) {
    const track = root.querySelector('.ooag-carousel-track');
    const prevBtn = root.querySelector('.ooag-prev');
    const nextBtn = root.querySelector('.ooag-next');
    if (!track || !prevBtn || !nextBtn) return;

    const getGap = () => {
      const v = getComputedStyle(track).getPropertyValue('--ooag-gap').trim();
      const px = parseFloat(v || '16');
      return isNaN(px) ? 16 : px;
    };
    const getCardWidth = () => {
      const firstCard = track.querySelector('.ooag-card');
      return firstCard ? firstCard.getBoundingClientRect().width : 0;
    };
    const getCardsVisible = () => {
      const cardW = getCardWidth();
      if (!cardW) return 1;
      return Math.max(1, Math.round(track.clientWidth / cardW));
    };

    // Prepare original card list
    const originals = Array.from(track.querySelectorAll('.ooag-card'));
    if (originals.length === 0) return;

    function cloneForLoop() {
      // Remove prior clones (if any)
      track.querySelectorAll('.ooag-clone').forEach(n => n.remove());

      const perView = getCardsVisible();

      // Create before/after clones
      const before = originals.slice(-perView).map(c => {
        const clone = c.cloneNode(true);
        clone.classList.add('ooag-clone');
        return clone;
      });
      const after = originals.slice(0, perView).map(c => {
        const clone = c.cloneNode(true);
        clone.classList.add('ooag-clone');
        return clone;
      });

      before.forEach(clone => track.insertBefore(clone, track.firstChild));
      after.forEach(clone => track.appendChild(clone));

      // Jump to first real slide (after "before" clones)
      requestAnimationFrame(() => {
        const gap = getGap();
        const cardW = getCardWidth();
        const offset = perView * (cardW + gap);
        track.scrollLeft = offset;
      });
    }

    function normalizeLoopPosition() {
      const perView = getCardsVisible();
      const gap = getGap();
      const cardW = getCardWidth();
      const page = (cardW + gap);

      const realCount = originals.length;
      const min = perView * page;                 // first real card left edge
      const max = (perView + realCount) * page;   // last real card right edge

      if (track.scrollLeft < min - page / 2) {
        track.scrollLeft += realCount * page;
      } else if (track.scrollLeft > max + page / 2) {
        track.scrollLeft -= realCount * page;
      }
    }

    function scrollByPages(direction) {
      const gap = getGap();
      const cardW = getCardWidth();
      const perView = getCardsVisible();
      if (!cardW) return;
      const delta = direction * (perView * (cardW + gap));
      track.scrollBy({ left: delta, behavior: 'smooth' });
    }

    function updateButtons() {
      // Loop mode ⇒ always enabled
      prevBtn.disabled = false;
      nextBtn.disabled = false;
    }

    // Events
    prevBtn.addEventListener('click', () => scrollByPages(-1));
    nextBtn.addEventListener('click', () => scrollByPages(1));

    track.addEventListener('scroll', () => {
      if (track.__ooag_scrolling) return;
      track.__ooag_scrolling = true;
      requestAnimationFrame(() => {
        normalizeLoopPosition();
        updateButtons();
        track.__ooag_scrolling = false;
      });
    });

    // Keyboard support
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByPages(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); scrollByPages(1); }
    });

    // Rebuild clones on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        cloneForLoop();
        updateButtons();
      }, 150);
    });

    // Init
    cloneForLoop();
    updateButtons();
  }

  function initAll() {
    document.querySelectorAll('.ooag-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
